import { cssColorHexToRgbA } from '~/utils/helpers/css';

export const CELL_WIDTH = 24;
export const CELL_HEIGHT = 24;
export const HEADER_DAY_HEIGHT = 36;
export const LEFT_COLUMN = 175;
export const CELL_SPACING = 1;
export const CUSTOM_PADDING = 2.5;
export const CELL_FONT_SIZE = '0.875rem';

export const TODAY_COLOR = '#434343';
export const WEEKEND_GRAY = '#BEBEBE';
export const MONTH_GRAY = '#D3D3D3';
export const DAY_GRAY = '#E8E8E8';

export const HOLIDAY_GREEN = '#43a047';
export const MILITARY_REHEARSAL_BROWN = '#a06a34';
export const SICK_LEAVE_RED = '#d70000';
export const MATERNITY_LEAVE_BLUE = '#07a2c5';
export const STUDY_LEAVE_YELLOW = '#ffd200';
export const CUSTOM_HOLIDAY_PURPLE = '#800075';
export const PUBLIC_HOLIDAY = '#196400';
export const OTHER = '#1457cb';

const alpha = 0.6;
export const outOfRangeBackground = `repeating-linear-gradient(
        45deg,
        ${cssColorHexToRgbA('#FFFFFF', alpha)},
        ${cssColorHexToRgbA('#FAFAFA', alpha)} 5px,
        ${cssColorHexToRgbA('#F5F5F5', alpha)} 5px,
        ${cssColorHexToRgbA('#EFEFEF', alpha)} 10px
      )`;
